import { Directive, HostListener, Input } from '@angular/core';
import { MatSelect, MatOption } from '@angular/material';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[plrSelectAll]'
})
export class SelectAllDirective {

  constructor(public select: MatSelect, public option: MatOption, public ngControl: NgControl) { 
    option.value = '-1';
  }
  @Input('plrSelectAll')
  selectAll: string;

  @HostListener('click', ['$event.target'])
  onClick() {
    var selected = [];
    if(this.option.selected) {
      selected.push('-1');
    } else {
      selected = undefined;
    }
    if (this.option.selected) {
      this.select.options.forEach(opt => {
        if (opt !== this.option) {
          selected.push(opt.value);
        }
      });
    }
    this.ngControl.viewToModelUpdate(selected); 
    this.select.value = selected;
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/select-all.directive.ts